import { MY_EQUIP_GA_EVENTS } from '../constants';

const getSelectedEquipmentGa = (isMoreAvailable: boolean) => {
  return isMoreAvailable
    ? MY_EQUIP_GA_EVENTS.CONTEXT
    : MY_EQUIP_GA_EVENTS.CHANGE;
};

export const getGaContext = (
  hasSelectedEquipment: boolean,
  isMoreAvailable: boolean
) => {
  return hasSelectedEquipment
    ? getSelectedEquipmentGa(isMoreAvailable)
    : MY_EQUIP_GA_EVENTS.SELECT;
};
